const COMMENTS = [
  {
    name: '漫画爱好者小王',
    text: '太棒了！之前一直到处找韩国漫画网站，要么不全要么打不开。这个韩国漫画网站大全真的太实用了，推荐的免费韩国漫画网站质量都很高，现在已经成为我每天必逛的网站入口了！',
    date: '2024-07-25',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20man%20avatar%20portrait%20with%20warm%20lighting%2C%20friendly%20expression%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20circular%20composition&width=100&height=100&seq=avatar-01&orientation=squarish',
  },
  {
    name: '韩漫忠实粉丝',
    text: '作为追了5年韩国漫画的老读者，这个网站的韩国漫画网站推荐真的很有水准。人气排行的榜单很准，最新动态更新也很快，再也不用担心错过更新了。强烈推荐给所有韩国漫画迷！',
    date: '2024-07-23',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20woman%20avatar%20portrait%20with%20soft%20lighting%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%2C%20circular%20composition&width=100&height=100&seq=avatar-02&orientation=squarish',
  },
  {
    name: '新入坑的读者',
    text: '刚入坑韩国漫画不久，之前完全不知道从哪里开始看。朋友推荐了这个韩国漫画网站入口，精选推荐里的作品每部都好好看！《我独自升级》和《全知读者视角》已经成了我的最爱，感谢站长的用心整理。',
    date: '2024-07-20',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Asian%20person%20avatar%20portrait%20with%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20background%2C%20professional%20headshot%2C%20circular%20composition&width=100&height=100&seq=avatar-03&orientation=squarish',
  },
];

export default function Comments() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          读者评价
        </h2>
        <p className="text-foreground-500 text-sm text-center mb-10">
          来自韩国漫画爱好者的真实反馈
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {COMMENTS.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-100 rounded-xl p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900">
                    {comment.name}
                  </h3>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                "{comment.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}